// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"4d1abebd","243":"528e2415","313":"541b33cd","314":"9c6acc69","379":"a6e9aa24","563":"f2bb6763","876":"7121cff6"}[chunkId] + ".chunk.js";
};